import { render, staticRenderFns } from "./VuetablePaginationInfo.vue?vue&type=template&id=af6cc3cc&"
import script from "./VuetablePaginationInfo.vue?vue&type=script&lang=js&"
export * from "./VuetablePaginationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../buildchain/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports